import { useAtomValue, useSetAtom } from "jotai/index";
import { authAtom } from "@/atoms/auth";
import { clientApi } from "@/utils/api-client";
import { userSettingsAtom } from "@/atoms/user-settings";
import { useCallback, useEffect, useMemo } from "react";
import { AuthSessionUsecase } from "@/usecases/auth/AuthSessionUsecase";
import { useAtom } from "jotai";
import { BookmarkUsecase } from "@/usecases/bookmark/BookmarkUsecase";
import { bookmarksAtom } from "@/atoms/bookmark";
import { SuggestionUsecase } from "@/usecases/suggestion/SuggestionUsecase";
import { suggestionsAtom } from "@/atoms/suggestion";
import { modelsAtom } from "@/atoms/model";
import { ModelUsecase } from "@/usecases/model/ModelUsecase";
import { useTranslation } from "react-i18next";

export const useAuthLayout = () => {
  const { i18n } = useTranslation();
  const [auth, setAuth] = useAtom(authAtom);
  const setBookmarks = useSetAtom(bookmarksAtom);
  const setSuggestions = useSetAtom(suggestionsAtom);
  const setModels = useSetAtom(modelsAtom);
  const { language } = useAtomValue(userSettingsAtom);

  const apiClient = useMemo(() => {
    return clientApi(language);
  }, [language]);

  const logout = useCallback(() => {
    setAuth({ type: "NotLogin" });
  }, [setAuth]);

  const authSession = useCallback(async () => {
    const current = await AuthSessionUsecase.currentAuthState(clientApi("en"));
    setAuth(current);
    if (current.type === "LoggedIn") {
      i18n.changeLanguage(current.user.langId);
    }
  }, [i18n, setAuth]);

  const otherStatusSession = useCallback(async () => {
    if (auth.type === "LoggedIn") {
      BookmarkUsecase.bookmarks(apiClient).then((bookmarksResponse) => {
        setBookmarks(bookmarksResponse.items);
      });
      SuggestionUsecase.suggestions(apiClient).then((response) => {
        setSuggestions(response.items);
      });
      ModelUsecase.models(apiClient).then((response) => {
        setModels(response.items);
      });
    }
  }, [apiClient, auth.type, setBookmarks, setModels, setSuggestions]);

  useEffect(() => {
    authSession();
  }, [authSession]);

  useEffect(() => {
    otherStatusSession();
  }, [otherStatusSession]);

  return { auth, apiClient, logout };
};
